import AgencyHelper from "features/Agency/agencyHelper";
import KTFormInput, { KTFormInputType } from "general/components/OtherKeenComponents/Forms/KTFormInput";
import KTBSDropdown from "general/components/OtherKeenComponents/KTBSDropdown";
import CustomDropdown2 from "general/components/Others/CustomDropdown2";
import AppColors from "general/constants/AppColors";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";

const FinancialAcceptanceProductTableView = ({
    dataName,
    data,
    setData,
    categoriesList,
    categoriesTotal,
    handleGetCategoriesList,
    chargeBrandOptions,
}) => {
    const headerConfig = [
        {
            label: 'Sản phẩm',
            required: true,
            rowSpan: 2,
            className: 'pl-3 rounded-top-left-lg',
        },
        // {
        //     label: 'Hãng sản xuất',
        //     required: false,
        //     rowSpan: 2,
        // },
        {
            label: 'Đơn vị tính',
            required: false,
            rowSpan: 2,
        },
        {
            label: 'Số lượng',
            required: true,
            rowSpan: 2,
        },
        {
            label: 'Đơn giá',
            required: true,
            colSpan: 2,
            className: 'text-center',
        },
        {
            label: 'Thành tiền',
            required: true,
            colSpan: 2,
        },
        {
            label: 'Thuế suất',
            required: true,
            colSpan: 2,
            className: 'text-center',
        },
        {
            label: 'Tiền thuế',
            required: true,
            colSpan: 2,
        },
        {
            label: 'Tổng tiền thanh toán',
            required: true,
            rowSpan: 2,
        },
        {
            label: 'Ghi chú',
            required: false,
            rowSpan: 2,
        },
        {
            label: '',
            required: false,
            rowSpan: 2,
            className: 'pr-3 w-40px rounded-top-right-lg',
        },
    ];

    const subHeaderConfig = [
        {
            label: 'Vật tư',
            required: true,
        },
        {
            label: 'Nhân công',
            required: true,
        },
        {
            label: 'Vật tư',
            required: true,
        },
        {
            label: 'Nhân công',
            required: true,
        },
    ];

    return (
        <div className="rounded-lg" style={{ border: `1px solid ${AppColors.gray[300]}` }}>
            <div className="table-responsive"
                style={{
                    maxWidth: 1052,
                    overflow: 'auto',
                }}
            >
                <table className="table mb-0">
                    <thead>
                        <tr>
                            {headerConfig.map((col, index) => (
                                <th
                                    key={index}
                                    className={col.className}
                                    style={{
                                        ...UIHelper.buildFontStyle('600', '12px', AppColors.gray[900]),
                                        backgroundColor: AppColors.gray[100],
                                        borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        borderRight: index !== headerConfig?.length - 1 && `1px solid ${AppColors.gray[300]}`, textAlign: 'center'
                                    }}
                                >
                                    {UIHelper.buildFormLabel(col.label, col.required)}
                                </th>
                            ))}
                        </tr>
                        {/* <tr>
                            {subHeaderConfig.map((subCol, index) => (
                                <th key={index} className={subCol.className}
                                    style={{
                                        ...UIHelper.buildFontStyle('600', '12px', AppColors.gray[900]),
                                        backgroundColor: AppColors.gray[100],
                                        borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        borderRight: `1px solid ${AppColors.gray[300]}`,
                                    }}
                                >
                                    {UIHelper.buildFormLabel(subCol.label, subCol.required)}
                                </th>
                            ))}
                        </tr> */}
                    </thead>
                    <tbody>
                        {data?.map((item, index) => (
                            <tr key={`ROW_${index}`}>
                                {/* Sản phẩm */}
                                <td className="border-0 pl-3 pr-0 pb-0" style={{ minWidth: '200px' }}>
                                    <CustomDropdown2
                                        ignoreConfirmClick
                                        name={`PRODUCT_${dataName}_${index}`}
                                        id={`PRODUCT_${dataName}_${index}`}
                                        toggleElement={
                                            <button
                                                type="button"
                                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            >
                                                {item?.categoryId ? item?.name : 'Chọn sản phẩm'}
                                            </button>
                                        }
                                        selectedValue={item}
                                        dropdownMenuItems={[{ name: 'Sản phẩm', role: 'INVENTORY_PRODUCT' }]}
                                        dropdownMenuClassName="overflow-auto w-100 position-relative"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        titleSearchable
                                        getSubItems={async (params) => {
                                            await handleGetCategoriesList(params);
                                            return {
                                                values: categoriesList?.map((category) => ({
                                                    id: category.categoryId,
                                                    name: category.name,
                                                    value: 'CATEGORY_PRODUCT',
                                                    productType: 'CATEGORY_PRODUCT',
                                                    item: { ...category, category: category.name },
                                                })),
                                                total: categoriesTotal,
                                            };
                                        }}
                                        onChange={(value) => {
                                            const selectedItem = value?.item;
                                            if (!selectedItem) return;

                                            const updated = [...data];
                                            updated[index] = {
                                                ...updated[index],
                                                tax: selectedItem.tax ?? 0,
                                                name: selectedItem.name ?? '',
                                                unit: selectedItem.unit ?? '',
                                                price: selectedItem.price ?? 0,
                                                taxRate: selectedItem.taxRate ?? 0,
                                                categoryId: selectedItem.categoryId ?? null,
                                                categoryCode: selectedItem.categoryCode ?? null,
                                                categoryType: dataName ?? '',
                                                amountBeforeTax: selectedItem.price ?? 0,
                                                amount: (selectedItem.price ?? 0) * (1 + (selectedItem.taxRate ?? 0)),
                                            };

                                            setData(updated);
                                        }}
                                        defaultValue={{ name: 'Sản phẩm', role: 'INVENTORY_PRODUCT' }}
                                        isDropdownForm
                                        searchable
                                        searchFormClassName="mx-3 my-1 search-form-border"
                                    />
                                </td>

                                {/* Hãng sản xuất */}
                                {/* <td className="border-0 pr-0 pb-0" style={{ minWidth: '120px', }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_brandId`}
                                        placeholder="Nhập tên"
                                        type={KTFormInputType.text}
                                        showUnit={false}
                                        value={_.find(chargeBrandOptions, (brand) => brand?.role === item?.brandId)?.name ?? ''}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], brandId: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td> */}

                                {/* Đơn vị tính */}
                                <td className="border-0 pr-0 pb-0" style={{ minWidth: '100px', }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_unit`}
                                        placeholder="Nhập đơn vị tính"
                                        type={KTFormInputType.text}
                                        showUnit={false}
                                        value={item?.unit}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], unit: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td>

                                {/* Số lượng */}
                                <td className="border-0 pr-0 pb-0" style={{ minWidth: '100px', }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_quantity`}
                                        placeholder="Nhập số lượng"
                                        type={KTFormInputType.currency}
                                        showUnit={false}
                                        value={item?.quantity}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            const amountBeforeTax = value * updated?.[index]?.price;
                                            const tax = Math.round(amountBeforeTax * updated?.[index]?.taxRate / 100);
                                            const amount = amountBeforeTax + tax;
                                            updated[index] = { ...updated[index], quantity: value, amountBeforeTax: amountBeforeTax, tax: tax, amount: amount };
                                            setData(updated);
                                        }}
                                    />
                                </td>

                                {/* Đơn giá */}
                                <td
                                    className="border-0 mb-0 pb-0 pr-0"
                                    style={{
                                        minWidth: '165px',
                                    }}
                                >
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_price`}
                                        placeholder="Nhập số tiền"
                                        type={KTFormInputType.currency}
                                        value={item?.price ?? 0}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            const amountBeforeTax = value * updated?.[index]?.quantity;
                                            const tax = Math.round(amountBeforeTax * updated?.[index]?.taxRate / 100);
                                            const amount = amountBeforeTax + tax;
                                            updated[index] = { ...updated[index], price: value, amountBeforeTax: amountBeforeTax, tax: tax, amount: amount };
                                            setData(updated);
                                        }}
                                    />
                                </td>

                                {/* Thành tiền */}
                                <td
                                    className="border-0 mb-0 pb-0 pr-0"
                                    style={{
                                        minWidth: '165px',
                                    }}
                                >
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_amountBeforeTax`}
                                        placeholder="Nhập số tiền"
                                        type={KTFormInputType.currency}
                                        value={item?.amountBeforeTax ?? 0}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            const laborAmount = value * updated?.[index]?.quantity;
                                            updated[index] = { ...updated[index], amountBeforeTax: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td>

                                {/* Thuế suất */}
                                <td
                                    className="border-0 mb-0 pb-0 pr-0"
                                    style={{
                                        minWidth: '100px',
                                    }}
                                >
                                    <KTBSDropdown
                                        name={`PRODUCT_${item?.modelId ?? index}_taxRate`}
                                        toggleElement={
                                            <button
                                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                                                type="button"
                                            >
                                                {
                                                    _.find(
                                                        AgencyHelper.Data.orderTaxRateOptions,
                                                        (taxRate) => taxRate.value == item?.taxRate
                                                    )?.name || "Chọn thuế suất"
                                                }
                                            </button>
                                        }
                                        selectedValue={item?.taxRate}
                                        dropdownMenuItems={AgencyHelper.Data.orderTaxRateOptions}
                                        dropdownMenuClassName="overflow-auto w-100 position-relative"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            const amountBeforeTax = updated?.[index]?.price * updated?.[index]?.quantity;
                                            const tax = Math.round(amountBeforeTax * value / 100);
                                            const amount = amountBeforeTax + tax;
                                            updated[index] = { ...updated[index], taxRate: Number(value), tax: tax, amount: amount };
                                            setData(updated);
                                        }}
                                        isDropdownForm={true}
                                    />
                                </td>

                                {/* Tiền thuế */}
                                <td
                                    className="border-0 mb-0 pb-0 pr-0"
                                    style={{
                                        minWidth: '165px',
                                    }}
                                >
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_tax`}
                                        placeholder="Nhập số tiền"
                                        type={KTFormInputType.currency}
                                        value={item?.tax ?? 0}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], tax: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td>

                                {/* Tổng tiền thanh toán */}
                                <td
                                    className="border-0 mb-0 pb-0 pr-0"
                                    style={{
                                        minWidth: '165px',
                                    }}
                                >
                                    <KTFormInput
                                        name={`MODEL_${item?.modelId ?? index}_amount`}
                                        placeholder="Nhập số tiền"
                                        type={KTFormInputType.currency}
                                        value={item?.amount ?? 0}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], amount: value };
                                            setData(updated);
                                        }}
                                        disabled={true}
                                    />
                                </td>

                                {/* Ghi chú */}
                                <td className="border-0 pr-0 pb-0" style={{ minWidth: '160px' }}>
                                    <KTFormInput
                                        name={`PRODUCT_${item?.modelId ?? index}_note`}
                                        placeholder="Nhập ghi chú"
                                        type={KTFormInputType.text}
                                        value={item?.note}
                                        onChange={(value) => {
                                            const updated = [...data];
                                            updated[index] = { ...updated[index], note: value };
                                            setData(updated);
                                        }}
                                    />
                                </td>

                                {/* Xóa */}
                                <td className="border-0 pr-3 pb-0 d-flex flex-column align-items-center justify-content-end">
                                    {UIHelper.buildNegativeButton(
                                        null,
                                        () => {
                                            if (data.length === 1) {
                                                setData([
                                                    {
                                                        tax: 0,
                                                        name: '',
                                                        unit: '',
                                                        price: 0,
                                                        amount: 0,
                                                        taxRate: 0,
                                                        quantity: 1,
                                                        categoryId: null,
                                                        categoryCode: null,
                                                        categoryType: null,
                                                        amountBeforeTax: 0,
                                                    },
                                                ]);
                                            } else {
                                                setData(_.filter(data, (_, i) => i !== index));
                                            }
                                        },
                                        <i className="fa-regular fa-trash-can" />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Thêm sản phẩm */}
            <div className="d-flex justify-content-between align-items-center px-3 my-3">
                <div>
                    {UIHelper.buildNegativeButton(
                        'Thêm sản phẩm',
                        () => {
                            setData([
                                ...data,
                                {
                                    tax: 0,
                                    name: '',
                                    unit: '',
                                    price: 0,
                                    amount: 0,
                                    taxRate: 0,
                                    quantity: 1,
                                    categoryId: null,
                                    categoryCode: null,
                                    categoryType: null,
                                    amountBeforeTax: 0,
                                },
                            ]);
                        },
                        <i className="fa-regular fa-circle-plus" />
                    )}
                </div>
                {/* <div className="d-flex align-items-center gap-1">
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>Tổng:</span>
                    <span style={UIHelper.buildFontStyle("600", "18px", AppColors.primary)}>
                        {Utils.formatNumber(
                            data.reduce(
                                (sum, item) => sum + (item?.materialAmount ?? 0) + (item?.laborAmount ?? 0),
                                0
                            )
                        )}{" "}
                        VNĐ
                    </span>

                </div> */}
            </div>
        </div>
    );
}

export default FinancialAcceptanceProductTableView;